module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "NameCard"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, _vm._l((_vm.names), function(name) {
    return _c('div', {
      staticClass: "container"
    }, [_c('div', {
      staticClass: "columns col-oneline"
    }, [_c('div', {
      staticClass: "column col-4"
    }, [_c('p', {
      staticClass: "float-left"
    }, [_vm._v("\n          " + _vm._s(name.value)), (name.favorite) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "column col-6"
    }, [_vm._v("\n          Total: "), _c('b', [_vm._v(_vm._s(_vm.endRating(name.rating)))]), _vm._v(" "), _c('br'), _vm._v("\n          Avg: " + _vm._s(_vm.average(name.rating)) + " - Count: " + _vm._s(_vm.ratingCount(name.rating)) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "column col-2"
    }, [_c('button', {
      staticClass: "btn btn-link",
      on: {
        "click": function($event) {
          _vm.deleteRecommendation(name['.key'])
        }
      }
    }, [_vm._v("Delete")])])])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "navbar"
  }, [_c('section', {
    staticClass: "navbar-primary"
  }, [_c('a', {
    staticClass: "navbar-brand mr-10",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('section', {
    staticClass: "navbar-section"
  }, [_c('div', {
    staticClass: "input-group input-inline"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-539c3043"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListUserRecommendations.vue
// module id = 122
// module chunks = 1